import { AnyIfEmpty } from "react-redux";
import { CLEAR_EXPORT_STAFF_STATE, GET_STAFF_LIST_FAILURE, GET_STAFF_LIST_REQUEST, GET_STAFF_LIST_SUCCESS, GET_EXPORT_STAFF_REQUEST, GET_EXPORT_STAFF_SUCCESS, GET_EXPORT_STAFF_FAILURE } from "../constants/staff.constants";

const initialState = {
    loading: false,
    data: [],
    count: 0,
    error: '',
    exportStaffLoading: false,
    exportStaffMessage: '',
    exportStaffError: '',
};

const staffManagementReducer = (state = initialState, action: AnyIfEmpty<object>) => {
    switch (action.type) {
        case GET_STAFF_LIST_REQUEST: {
            return {
                ...state,
                loading: true,
                error: '',
            }
        }

        case GET_STAFF_LIST_SUCCESS: {
            const { staffLocations = [], count, shouldAppend } = action.payload;
            return {
                ...state,
                loading: false,
                data: shouldAppend ? [...state.data, ...staffLocations] : staffLocations,
                count: count || 0,
                error: ''
            }
        }

        case GET_STAFF_LIST_FAILURE: {
            return {
                ...state,
                loading: false,
                data: [],
                count: 0,
                error: action?.payload
            }
        }

        case GET_EXPORT_STAFF_REQUEST: {
            return {
                ...state,
                exportStaffLoading: true,
                exportStaffError: '',
                exportStaffMessage: '',
            }
        }

        case GET_EXPORT_STAFF_SUCCESS: {
            return {
                ...state,
                exportStaffLoading: false,
                exportStaffMessage: action.payload,
                exportStaffError: ''
            }
        }

        case GET_EXPORT_STAFF_FAILURE: {
            return {
                ...state,
                exportStaffLoading: false,
                exportStaffError: action?.payload
            }
        }

        case CLEAR_EXPORT_STAFF_STATE: {
            return {
                ...state,
                exportStaffLoading: false,
                exportStaffMessage: '',
                exportStaffError: '',
            }
        }


        default: {
            return {
                ...state,
                loading: false
            }
        }
    }
}

export default staffManagementReducer